import { createContext, useContext, type ReactNode } from 'react';
import { Modal } from '@mantine/core';
import { useShiftPwaControlsController } from './useShiftPwaControlsController';
import classes from './shift-pwa-controls.module.scss';

const ShiftPwaContext = createContext<ReturnType<typeof useShiftPwaControlsController> | null>(null);

export const ShiftPwaProvider = ({ children }: { children: ReactNode }) => {
  const controller = useShiftPwaControlsController();
  return <ShiftPwaContext.Provider value={controller}>
    {children}
    <Modal opened={controller.instructionsOpen} onClose={controller.onCloseInstructions} title="התקנת SHIFT" centered
      classNames={{ inner: 'shiftSheetInner', content: 'shiftSheetContent' }}>
      <div dir="rtl" className={classes.instructions}>
        {controller.apple ? <>
          <p>ב-iPhone ההתקנה מסתיימת דרך Safari:</p>
          <ol>
            <li>ב-Safari פתחו את <strong>תפריט העמוד (…) ואז שיתוף</strong>, או את כפתור השיתוף בסרגל.</li>
            <li>גללו ברשימת הפעולות ובחרו <strong>הוספה למסך הבית</strong>.</li>
            <li>השאירו את <strong>פתיחה כיישום אינטרנט</strong> פעיל ולחצו <strong>הוספה</strong>.</li>
          </ol>
          <p>לא מופיעה האפשרות? בתחתית רשימת השיתוף לחצו ״עריכת פעולות״ והוסיפו ״הוספה למסך הבית״.</p>
          <p>פתחו את SHIFT מהסמל החדש במסך הבית. להתראות נדרש iOS 16.4 ומעלה.</p>
        </> : <p>פתחו את תפריט הדפדפן ובחרו ״התקנת אפליקציה״ או ״הוספה למסך הבית״.</p>}
        <button type="button" className="primaryAction" onClick={controller.onCloseInstructions}>הבנתי</button>
      </div>
    </Modal>
  </ShiftPwaContext.Provider>;
};

export const ShiftPwaControls = ({ onInstallAction }: { onInstallAction?: () => void }) => {
  const controller = useContext(ShiftPwaContext);
  if (!controller) return null;
  return <>
      {!controller.standalone && <button type="button" className="secondaryAction" disabled={controller.busy}
        onClick={() => { onInstallAction?.(); void controller.onInstall(); }}>התקנת SHIFT</button>}
      {controller.standalone && controller.isAuthenticated && controller.result?.status !== 'registered' &&
        <button type="button" className="secondaryAction" disabled={controller.busy}
          onClick={() => void controller.onEnableNotifications()}>הפעלת התראות</button>}
      {controller.result && <span role="status" className={classes.status}>{controller.result.message}</span>}
  </>;
};